import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, UserRound } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ROUTES } from '@/config/constants';
import { ACTIVE_PILL } from '../inspector/controls';

/**
 * WINR Studio's top-level sections: Community (theme documents for spaces you
 * own) and Profile (your public identity). Lives in both studio headers so
 * the studio reads as one product with two creative surfaces.
 */
export function StudioSectionNav({ active }: { active: 'community' | 'profile' }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-0.5 rounded-lg border border-white/[0.06] bg-ink-950/70 p-0.5">
      <SectionBtn
        icon={<LayoutDashboard size={12} />}
        label="Community"
        active={active === 'community'}
        onClick={() => navigate(ROUTES.themeStudio)}
      />
      <SectionBtn
        icon={<UserRound size={12} />}
        label="Profile"
        active={active === 'profile'}
        onClick={() => navigate(ROUTES.profileStudio)}
      />
    </div>
  );
}

function SectionBtn({
  icon,
  label,
  active,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[12px] font-bold transition-all',
        active ? ACTIVE_PILL : 'text-mid hover:text-hi',
      )}
    >
      {icon}
      <span className="hidden md:inline">{label}</span>
    </button>
  );
}
